module.exports = __webpack_public_path__ + "static/media/studio-slide3.7f8a852b.png";